import React, { useMemo } from "react";
import { Card, Table, Th, Td } from "./ui";
import { fmtIDR } from "../lib/utils";
import { Tag } from "lucide-react";

// Rekap per Nama Grup — untuk dicocokkan dengan tagihan vendor
export default function CostGroupRecap({ costs, active, onPick }) {
  const groups = useMemo(() => {
    const m = new Map();
    costs.forEach((c) => {
      if (!c.group_label) return;
      const g = m.get(c.group_label) || { label: c.group_label, n: 0, total: 0, settled: 0, pending: 0, vendors: new Set() };
      const amt = Number(c.amount || 0);
      g.n += 1; g.total += amt;
      if (c.is_settled) g.settled += amt; else g.pending += amt - Number(c.paid_amount || 0);
      if (c.vendor_name) g.vendors.add(c.vendor_name);
      m.set(c.group_label, g);
    });
    return [...m.values()].sort((a, b) => a.label.localeCompare(b.label));
  }, [costs]);
  if (!groups.length) return null;
  return (
    <Card className="mb-5" data-testid="cost-group-recap">
      <div className="px-4 py-3 border-b border-slate-200 flex items-center gap-2 bg-blue-50">
        <Tag size={14} className="text-blue-700"/>
        <h3 className="font-bold text-sm">Rekap Total per Grup</h3>
        <span className="text-xs text-slate-500">{groups.length} grup · klik baris untuk filter daftar</span>
      </div>
      <Table>
        <thead><tr>
          <Th>Nama Grup</Th><Th>Vendor</Th><Th className="text-right">Item</Th><Th className="text-right">Total Biaya</Th>
          <Th className="text-right">Sudah Settle</Th><Th className="text-right">Belum Dibayar</Th>
        </tr></thead>
        <tbody>
          {groups.map((g) => (
            <tr key={g.label} data-testid={`group-recap-row-${g.label}`} onClick={() => onPick(active === g.label ? "" : g.label)}
              className={`cursor-pointer ${active === g.label ? "bg-blue-100" : "hover:bg-slate-50"}`}>
              <Td className="font-bold">{g.label}</Td>
              <Td className="text-xs text-slate-600">{[...g.vendors].join(", ") || "-"}</Td>
              <Td className="text-right">{g.n}</Td>
              <Td className="text-right font-mono font-bold" data-testid={`group-recap-total-${g.label}`}>{fmtIDR(g.total)}</Td>
              <Td className="text-right font-mono text-emerald-700">{fmtIDR(g.settled)}</Td>
              <Td className="text-right font-mono text-orange-700">{fmtIDR(g.pending)}</Td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
}
